import React, { useState, useCallback, useEffect } from "react";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { setPlayer1, setPlayer2 } from "../store/slices/players";
import useAuth from "../hooks/useAuth";
import axios from "../services/axios";

import JogadorInput from "../components/jogadorInput";
import AvatarModal from "../components/avatarModal";

export default function CadastroUsuarios() {
  const [preference, setPreference] = useState(0);
  const [modal, setModal] = useState(0);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { player1, player2 } = useSelector((state) => state.players);
  const { user, setUser } = useAuth();

  useEffect(() => {
    if (player1.gender === 2 && player2.gender === 1) {
      setPreference(0);
    }
    if (player1.gender === 1 && player2.gender === 1) {
      setPreference(1);
    }
    if (player1.gender === 2 && player2.gender === 2) {
      setPreference(2);
    }
  }, [player1, player2]);

  useEffect(() => {
    if (!user.id_jogadores) {
      return;
    }
    axios
      .get(`/user/getPlayers?id_jogadores=${user.id_jogadores}`)
      .then((res) => {
        const { data } = res;

        let p1 = {
          name: data.jogador_1,
          gender: data.gender_1,
          orientation: data.orientation_1,
          orientationCalc: data.orientation_calc_1,
          avatar: data.avatar_1
            ? `https://desafios-picantes-bucket.dev12br.com${data.avatar_1}`
            : "https://desafios-picantes-bucket.dev12br.com/personagens/avatar/avatar_mulher_mulherGato.png",
        };
        let p2 = {
          name: data.jogador_2,
          gender: data.gender_2,
          orientation: data.orientation_2,
          orientationCalc: data.orientation_calc_2,
          avatar: data.avatar_2
            ? `https://desafios-picantes-bucket.dev12br.com${data.avatar_2}`
            : "https://desafios-picantes-bucket.dev12br.com/personagens/avatar/avatar_homem_bombeiro.png",
        };

        dispatch(setPlayer1(p1));
        dispatch(setPlayer2(p2));

        localStorage.setItem("SPICY_PLAYER1", JSON.stringify(p1));
        localStorage.setItem("SPICY_PLAYER2", JSON.stringify(p2));
      })
      .catch(console.log);
  }, [user]);

  const getPreferenceText = useCallback(() => {
    switch (preference) {
      case 0:
        return t("hetero");
      case 1:
        return t("gay");
      case 2:
        return t("lesbico");
      default:
        return "";
    }
  }, [preference]);

  const handleSubmit = (e) => {
    e.preventDefault();

    let p1 = {
      name: e.target["player1-name"].value,
      gender: 2,
      orientation: 0,
      orientationCalc: 2,
    };
    let p2 = {
      name: e.target["player2-name"].value,
      gender: 1,
      orientation: 0,
      orientationCalc: 1,
    };
    switch (preference) {
      case 1:
        //  Gay
        p1.gender = 1;
        p1.orientation = 1;
        p1.orientationCalc = 3;

        p2.gender = 1;
        p2.orientation = 1;
        p2.orientationCalc = 3;
        break;
      case 2:
        // Lesbica
        p1.gender = 2;
        p1.orientation = 1;
        p1.orientationCalc = 4;

        p2.gender = 2;
        p2.orientation = 1;
        p2.orientationCalc = 4;
        break;
      default:
        break;
    }

    const formData = new FormData();

    formData.append("player1-image", e.target["player1-image"].files[0]);
    formData.append("player2-image", e.target["player2-image"].files[0]);

    formData.append("id_usuario", user.id_usuario);
    formData.append("player1[nome]", p1.name);
    formData.append("player1[genero]", p1.gender);
    formData.append("player1[orientacao]", p1.orientation);
    formData.append("player1[orientacaoCalc]", p1.orientationCalc);
    formData.append(
      "player1[imageAvatar]",
      e.target["player1-image-avatar"].value
    );

    formData.append("player2[nome]", p2.name);
    formData.append("player2[genero]", p2.gender);
    formData.append("player2[orientacao]", p2.orientation);
    formData.append("player2[orientacaoCalc]", p2.orientationCalc);
    formData.append(
      "player2[imageAvatar]",
      e.target["player2-image-avatar"].value
    );

    axios
      .post("/user/postPlayers", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        const { data } = res;

        setUser({ ...user, id_jogadores: data.id_jogadores });
        p1.avatar = data.avatar_1;
        p2.avatar = data.avatar_2;

        dispatch(setPlayer1(p1));
        dispatch(setPlayer2(p2));

        localStorage.setItem("SPICY_PLAYER1", JSON.stringify(p1));
        localStorage.setItem("SPICY_PLAYER2", JSON.stringify(p2));
      })
      .catch(console.log);

    navigate("/home");
  };

  const getUrl = () => {
    return "https://gameforcouple.page.link/partners";
  };

  return (
    <div className="container no-scroll mx-auto">
      <div className="flex flex-col justify-center items-center h-full">
        <div className="scroll">
          <form
            onSubmit={handleSubmit}
            className="h-full p-3 grid grid-cols-1 gap-4 grid-rows-[182px_auto_150px]"
          >
            <div className="mt-10 flex text-center flex-col items-center">
              <div className="preference-select mt-10">
                <div
                  className={`preference-item ${preference === 0 && "active"}`}
                  onClick={() => setPreference(0)}
                >
                  <img
                    src={require("../assets/icons/hetero.png")}
                    alt="hetero"
                  />
                </div>
                <div
                  className={`preference-item ${preference === 1 && "active"}`}
                  onClick={() => setPreference(1)}
                >
                  <img src={require("../assets/icons/gay.png")} alt="gay" />
                </div>
                <div
                  className={`preference-item ${preference === 2 && "active"}`}
                  onClick={() => setPreference(2)}
                >
                  <img
                    src={require("../assets/icons/lesbica.png")}
                    alt="lesbica"
                  />
                </div>
              </div>

              <div className="flex flex-col mt-4">
                <span className="font-semibold text-lg">
                  {getPreferenceText()}
                </span>
                <small className="text-xs">{t("fill")}</small>
              </div>
            </div>

            <div className="self-center">
              <h1 className="text-center font-bold text-3xl font-metropolis">
                {t("players")}
              </h1>

              <div className="mt-10 ms-4 me-4">
                <div>
                  <JogadorInput
                    defaultValue={player1?.name || ""}
                    name="player1"
                    gender={[0, 2].includes(preference) ? 1 : 0}
                    setAvatarModal={setModal}
                  />
                </div>
                <div className="mt-4">
                  <JogadorInput
                    defaultValue={player2?.name || ""}
                    name="player2"
                    gender={[0, 1].includes(preference) ? 0 : 1}
                    setAvatarModal={setModal}
                  />
                </div>
                <div className="text-center mt-8">
                  <a
                    href={getUrl()}
                    target="_blank"
                    className="font-semibold select-none font-metropolis underline p-1 rounded-md bg-[--gender-background]"
                    rel="noreferrer"
                  >
                    {t("morePlayer")}
                  </a>
                </div>
              </div>
            </div>

            <div className="m-6 mt-10">
              <button className="btn btn-brand w-full">{t("start")}</button>
            </div>
          </form>
        </div>
      </div>
      <AvatarModal visible={modal} setVisible={setModal} />
    </div>
  );
}
